
import Vue from 'vue';

export default Vue.extend({
  name: "XSwitcherCustom",
  props: ["switcherState", "disabled"],
  data() {
    return {}
  },
  methods: {
    onChange() {
      if (this.disabled) {
        return;
      }
      if (this.switcherState) {
        this.$emit("closeAll");
      } else {
        this.$emit("startAll");
      }
    }
  }
})
